import { User } from './User'

export class SupplyChainUser extends User {
  static type = 'supplychainuser'
  type = SupplyChainUser.type
}
